export default __webpack_public_path__ + "static/area_2-2721f16b594d8a19b621e3dff538839a.jpg";